import { render } from "./BusinessGoals.vue?vue&type=template&id=9730904e&scoped=true"
import script from "./BusinessGoals.vue?vue&type=script&lang=js"
export * from "./BusinessGoals.vue?vue&type=script&lang=js"

import "./BusinessGoals.vue?vue&type=style&index=0&id=9730904e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9730904e"]])

export default __exports__